module.exports = __webpack_public_path__ + "img/plus-small.4a487420.svg";